module.exports = require("core-js/library/fn/array/is-array");


/*****************
 ** WEBPACK FOOTER
 ** ./~/@babel/runtime-corejs2/core-js/array/is-array.js
 ** module id = 645
 ** module chunks = 0
 **/